import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './components/Home/home';
import Shop from './components/Shop/shop';
import Blogs from './components/Blogs/blogs';
import AboutUs from './components/AboutUs/aboutUs';
import ContactUs from './components/ContactUs/contactUs';
import ViewDress from './components/ProductPage/productPage';
import { Provider } from 'react-redux';
import  store  from './store/store';
import SignUp from './components/SignUp/signUp';
import Login from './components/Login/login';
import GetOtp from './components/SignUp/getOtp';
import ProfilePage from './components/ProfilePage/profilePage';
import ProductPage from './components/ProductPage/productPage';
import Checkout from './components/Checkout/checkout';
import OrderDetail from './components/OrderDetails/orderDetails';
import PrivacyPolicy from './components/StaticPages/privacyPolicy';
import ExchangeAndReturn from './components/StaticPages/exchangeAndReturn';
import TermsAndConditions from './components/StaticPages/termsAndConditions';
import ForgotPassword from './components/ForgotPassword/forgotPassword';
import ResetPassword from './components/ForgotPassword/resetPassword';

function App() {
  
  return (
    <Provider store={store}>
    <Router>
      <Routes>
        {/* Route for the Home component */}
        <Route path="/" element={<Home />} />
        
        {/* Route for the Shop component */}
        <Route path="/shop" element={<Shop />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/view/product/:id" element={<ProductPage />} />
        <Route path="/signup" element={<SignUp/>}/>
        <Route path="/getotp" element={<GetOtp/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/forgot-password" element={<ForgotPassword/>}/>
        <Route path="/reset-password" element={<ResetPassword/>}/>
        {/* <Route path="/profile" element={<ProfilePage/>}/> */}
        <Route path="/profile" element={<ProfilePage activeSection="YOUR ORDERS" />} />
        <Route path="/profile/:section" element={<ProfilePage />} />

        <Route path="/checkout" element={<Checkout fromCart={true} />}/>
        <Route path="/order/:orderId" element={<OrderDetail />} /> {/* New Order Detail Route */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/exchange-and-return" element={<ExchangeAndReturn />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

        
      </Routes>
    </Router>
    </Provider>
  );
}

export default App;
